import React from 'react';

import Alert from '@react/react-spectrum/Alert';
import Heading from '@react/react-spectrum/Heading';
import LabeledValue from 'components/LabeledValue';
import Wait from '@react/react-spectrum/Wait';

import { useAEP } from 'data/hooks';
import SandboxStatus from 'components/SandboxStatus';

export default function Properties({ id }) {
  const { loading, error, data } = useAEP(id, {
    streamingEndpoint: true,
    details: true
  });

  if (loading) {
    return (
      <div className="properties">
        <Heading size={3}>Properties</Heading>
        <Wait size="S" />
      </div>
    );
  }

  if (error) {
    return (
      <div>
        <Alert variant="error" header="Error">
          {error.message}
        </Alert>
      </div>
    );
  }

  const { streamingEndpoint } = data.aep;

  return (
    <div className="properties">
      <Heading size={3}>Properties</Heading>

      <section>
        <div className="labeled-value">
          <Heading variant="subtitle3">STATUS</Heading>

          <SandboxStatus loading={loading} error={error} data={data} />
        </div>

        <LabeledValue
          label="Streaming endpoint URL"
          value={streamingEndpoint}
          emptyMessage="Streaming endpoint not found, please use Quick Setup to create it"
        />
      </section>
    </div>
  );
}
